import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type User from 'types/User'

export type SnackbarStatus = 'info' | 'success' | 'warning' | 'error' | 'neutral'

export interface GlobalState {
  user?: User

  snackbar: {
    message: string
    status: SnackbarStatus
  }
}

// Initial state
const initialState: GlobalState = {
  snackbar: {
    message: '',
    status: 'neutral'
  }
}

export const globalStateSlice = createSlice({
  name: 'globalState',
  initialState,
  reducers: {
    initializeUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload
    },

    showSnackbar: (state, action: PayloadAction<{ message: string, status: SnackbarStatus }>) => {
      state.snackbar.status = action.payload.status
      state.snackbar.message = action.payload.message
    }
  }
})

export const {
  initializeUser,
  showSnackbar
} = globalStateSlice.actions

export default globalStateSlice.reducer
